export default __webpack_public_path__ + "static/levlaz-0a4d0ad9e8246a56cf9eb8ae4a5f633d.jpg";